import React from 'react'
import styles from './title.module.css'

const getTitleClass = (titleNumber, align) => {
  if (!align) {
    return styles[titleNumber]
  } else if (align === 'left') {
    return styles[`${titleNumber}Left`]
  }
}

export const Title2 = (props) => {
  const titleClass = getTitleClass('h2', props?.align)
  return (
    <h2 className={titleClass}>
      {props.label && props.label}
      {!props.label && props.children}
    </h2>
  )
}

export const Title3 = (props) => {
  const titleClass = getTitleClass('h3', props?.align)
  return (
    <h3 className={titleClass}>
      {props.label && props.label}
      {!props.label && props.children}
    </h3>
  )
}

export const Title4 = (props) => {
  const titleClass = getTitleClass('h4', props?.align)
  return (
    <h4 className={titleClass}>
      {props.label && props.label}
      {!props.label && props.children}
    </h4>
  )
}

export const Title5 = (props) => {
  const titleClass = getTitleClass('h5', props?.align)
  return (
    <h5 className={titleClass}>
      {props.label && props.label}
      {!props.label && props.children}
    </h5>
  )
}

export const Title6 = (props) => {
  const titleClass = getTitleClass('h6', props?.align)
  return (
    <h6 className={titleClass}>
      {props.label && props.label}
      {!props.label && props.children}
    </h6>
  )
}
